import { Button } from 'devextreme-react'
import { Column } from 'devextreme-react/data-grid'
import React from 'react'
import { Card } from 'reactstrap'
import Breadcrumb from '../../components/common/breadcrumb'
import DatagridCustom from '../../components/common/datagrid/custom-datagrid'
const OnayEkrani = () => {
    return (
        <>
            <Breadcrumb current="Onay Ekranı" />
            <Card className='p-4'>
                <DatagridCustom
                    dataSource={dataSource}
                >
                    <Column dataField="ID" caption="Talep ID" alignment='center' />
                    <Column dataField="talepedenTarih" caption="Talep Tarihi" alignment='center' />

                    <Column dataField="islem" caption="İşlem" alignment='center' />
                    <Column dataField="sase" caption="Şase" alignment='center' />
                    <Column dataField="talepeden" caption="Talep Eden" alignment='center' />
                    <Column caption='İşlem' cellRender={
                        () => (<div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '10px'
                        }}><Button color='primary' size='sm'>
                                <i className="fa fa-check font-success
                            "></i>
                            </Button> <Button color='danger' size='sm'>
                                <i className="fa fa-times font-danger
                            "></i>
                            </Button> </div>)}
                        alignment='center'
                        width={90}
                    />
                </DatagridCustom>

            </Card>

        </>
    )
}

export default OnayEkrani


const dataSource = [
    {
        ID: 1,
        islem: "PDI Girişi",
        sase: "E3CT3AAW0OO167183",
        talepeden: "User1",
        talepedenTarih: "12.12.2021",
    },
    {
        ID: 2,
        islem: "PDI Çıkış",
        sase: "NT13157CUZT261120",
        talepeden: "User2",
        talepedenTarih: "12.12.2021",
    },
]